import {
  filterByRefId,
  toExcess,
} from 'scenes/common/api/quote/marshaller/excess';
import { WireExcess } from 'scenes/common/api/quote/types/';

import { WireCoverageName, WireLandlordQuotePayload } from '../types';

const findExcessesByCoverage = (
  excesses: WireExcess[],
  coverage: WireCoverageName
) => excesses.filter(({ id, name }) => filterByRefId(id) && name === coverage);

const unmarshalExcesses = (
  excesses: WireExcess[],
  coverage: WireCoverageName
) => findExcessesByCoverage(excesses, coverage).map(toExcess);

export const unmarshalBuildingExcesses = (quote: WireLandlordQuotePayload) =>
  unmarshalExcesses(quote.excesses, WireCoverageName.Building);

export const unmarshalContentsExcesses = (quote: WireLandlordQuotePayload) =>
  unmarshalExcesses(quote.excesses, WireCoverageName.Contents);

const unmarshalSelectedExcess = (
  excesses: WireExcess[],
  coverage: WireCoverageName
) =>
  findExcessesByCoverage(excesses, coverage)
    .filter((excess) => excess.selected)
    .map(toExcess)[0];

export const unmarshalSelectedBuildingExcess = (
  quote: WireLandlordQuotePayload
) => unmarshalSelectedExcess(quote.excesses, WireCoverageName.Building);

export const unmarshalSelectedContentsExcess = (
  quote: WireLandlordQuotePayload
) => unmarshalSelectedExcess(quote.excesses, WireCoverageName.Contents);
